import { Box, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

/**
 * Consistent header for every waste submission stepper step — an `h5` title
 * (matching the Overview's "Submission Overview") and an optional description.
 * Keeps section headers uniform across steps that embed reused profile sections
 * (which carry their own sub-headers). `titleAdornment` renders inline beside
 * the title (e.g. a status chip);
 * `action` renders right-aligned at the end of that row.
 */
export function StepHeader({
  title,
  description,
  titleAdornment,
  action,
}: {
  title: string;
  description?: ReactNode;
  titleAdornment?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1.5}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Typography variant="h5">{title}</Typography>
          {titleAdornment}
        </Stack>
        {action}
      </Stack>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {description}
        </Typography>
      )}
    </Box>
  );
}
